// @flow
import React, { Component, useEffect, useMemo } from 'react';
import { Elements, ElementsConsumer } from '@stripe/react-stripe-js';
import { StyleSheet, View } from 'react-native';
import { loadStripe } from '@stripe/stripe-js';
import CheckoutForm from './components/CheckoutForm';
import I18n from '../../../../../lib/i18n';
import config from '../../../../../config';
import { onStripeSuccess, onStripeError } from './StripePayment.common';
import type { StripePaymentCommonProps } from './StripePayment.common';
import { DotsLoader } from 'trpc-react-native-ui';
import theme from '../../../../../theme-config';
import { GradientPage } from '../../../../common';

const stripePromise = loadStripe(config.STRIPE_PUBLISHABLE_KEY);

// $FlowFixMe use FunctionComponent when Flow is updated
export const StripePayment: Component<StripePaymentCommonProps> = props => {
  const styles = useMemo(getStyles, []);
  const { initStripePaymentMean, paymentInfo } = props;

  useEffect(() => {
    initStripePaymentMean();
  }, []);

  if (!paymentInfo?.stripeIntentId) {
    return (
      <View style={styles.loading} testID={'newPaymentMeanPageContainer'}>
        <DotsLoader activeBackground={theme.primary} background={theme.primary} />
      </View>
    );
  }

  return (
    <GradientPage maxWidth={600}>
      <Elements stripe={stripePromise}>
        <ElementsConsumer>
          {({ elements, stripe }) => (
            <CheckoutForm
              onStripeError={onStripeError}
              onStripeSuccess={stripePaymentMethod => onStripeSuccess(stripePaymentMethod, props)}
              elements={elements}
              stripe={stripe}
              cardDetailsText={I18n.t('NewPaymentMeanPage.web.cardDetails')}
              confirmOrderText={I18n.t('NewPaymentMeanPage.web.confirmOrder')}
            />
          )}
        </ElementsConsumer>
      </Elements>
    </GradientPage>
  );
};

function getStyles() {
  return StyleSheet.create({
    loading: {
      alignItems: 'center',
      backgroundColor: theme.white,
      flex: 1,
      justifyContent: 'center',
    },
  });
}
